module.exports = __webpack_public_path__ + "img/zhrf.4431b2f9.jpg";